import mod from "../lib/index.js";

export default mod["default"];
export const asOptions = mod.asOptions;
export const emphasisOptions = mod.emphasisOptions;
export const text = mod.text;
